/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function refreshCart() {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
}

// PDP code to hide unavailable variants
// let url = window.location.href;
// if(url.includes('/products/') && jQuery('.product-form__option').length === 3 ) {
//   let handle = url.slice(url.indexOf('products/'));
//   handle = handle.split('?')[0] + '.js';
//   var prevOptionSelected = ''
//   let option1 = jQuery('.block-swatch__radio:checked + .block-swatch__item .block-swatch__item-text').text()
//   var request = request = jQuery.getJSON(window.Shopify.routes.root + handle, function(product) {
//         return product
//   }).done(function(product) {
//       updateSwatches(product, option1);
//   })
//   document.addEventListener('variant:changed', function(event) {
//     option1 = jQuery('.block-swatch__radio:checked + .block-swatch__item .block-swatch__item-text').text()
//     request.done(function(product) {
//         updateSwatches(product, option1);
//     })
//   })

//   function updateSwatches(product, option1) {
//        $('.variant-swatch-list .variant-swatch.variant-swatch--unavailable').removeClass('variant-swatch--unavailable');
//               prevOptionSelected = option1
//               $('.variant-swatch-list .variant-swatch').each(function(ind, item) {
//                 let option2 = $(item).find('.variant-swatch__radio').val();
//                 let isAvailable = false;
//                 for(let i = 0; i < product.variants.length; i++) {
//                   if(product.variants[i].option1 === option1 && product.variants[i].option2 === option2) {
//                     isAvailable = true;
//                   }
//                 }
//                 if(!isAvailable) {
//                   $(item).addClass('variant-swatch--unavailable');
//                 }
//       })
//   }
// }

swAppInterval = setInterval(() => {
  if (window._swat != undefined) {
    window._swat.evtLayer.addEventListener("sw:addedtocart", function (e) {
      refreshCart();
      clearInterval(swAppInterval);
    });
  }
}, 1000);

/* 

  Handle Unavailable Variants 
  Source: https://github.com/JonoHall/Shopify-Hide-Unavailable-Options

*/

if (window.theme.pageType == "product") {
  document.addEventListener("DOMContentLoaded", () => {
    const variantSelects = document.querySelector(".product-info-container");
    const productFormOptions = Array.from(
      variantSelects.querySelectorAll(".variant-option-selector")
    );
    const productJson = JSON.parse(
      variantSelects.querySelector("[data-variants-json]").textContent
    );

    let selectedOptions = [];

    variantSelects.addEventListener("change", rebuildOptions);

    rebuildOptions();

    // gather a list of valid combinations of options, check to see if the input passed to it matches in a chain of valid options.
    function validCombo(inputValue, optionLevel) {
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (
            productJson[i].option1 == selectedOptions[0] &&
            productJson[i].option2 == inputValue
          ) {
            return true;
          }
        } else {
          if (
            productJson[i].option1 == selectedOptions[0] &&
            productJson[i].option2 == selectedOptions[1] &&
            productJson[i].option3 == inputValue
          ) {
            return true;
          }
        }
      }
      return false;
    }

    function rebuildOptions() {
      selectedOptions = productFormOptions.map((option) => {
        return Array.from(option.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });

      // loop through the option sets starting from the 2nd set and disable any invalid options
      for (
        let optionLevel = 1, n = productFormOptions.length;
        optionLevel < n;
        optionLevel++
      ) {
        const inputs = productFormOptions[optionLevel].querySelectorAll("input");

        inputs.forEach((input) => {
          input.disabled = validCombo(input.value, optionLevel) ? false : true;
          //get the label for the current input (this is what the user clicks)
          const label = productFormOptions[optionLevel].querySelector(
            `label[for="${input.id}"]`
          );

          label.style.display = input.disabled ? "none" : "";
          label.parentElement.style.display = input.disabled ? "none" : "";
          // label.style.opacity = input.disabled ? 0.5 : 1;
          // label.style.borderStyle = input.disabled ? "dashed" : "solid";
          // label.style.textDecoration = input.disabled ? "none" : "";
        });
      }

      //if the default selected option is disabled with the function above, select the first available option instead
      for (
        let optionLevel = 1,
          productFormOptionsLength = productFormOptions.length,
          change = false;
        optionLevel < productFormOptionsLength && !change;
        optionLevel++
      ) {
        if (
          productFormOptions[optionLevel].querySelector("input:checked")
            .disabled === true
        ) {

          const firstAvailableLabel = productFormOptions[optionLevel].querySelector(
            "input:not(:disabled)"
          ).parentElement.querySelector("label");

          setTimeout(() => {
            firstAvailableLabel.click();
          }, 10);

          // change = (productFormOptions[optionLevel].querySelector(
          //   "input:not(:disabled)"
          // ).checked = true);
          
        }
        
        // if a new option has been selected, restart the whole process
        if (change){
          variantSelects.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  });
}
